const enums = {
    /** Old pages **/
    LOGIN: '/login',
    FEDERATED_EMAIL_LOGIN: '/sso',
    FEDERATED_TOKEN_LOGIN: '/federated-token-login/:token',
    LOGIN_DASHBOARD: '/login-dashboard',
    LOGIN_DASHBOARD_POPUP: '/login-dashboard-popup/:platform',
    FORGOT_PASSWORD: '/forgot-password',
    ACCOUNT_CONFLICT: '/account-conflict/:token/:email',
    FORGOT_PASSWORD_FINISH: '/forgot-password-finish/:token',
    ACCOUNT_UNIFICATION: '/account-unification',
    CUSTOM_LOGIN: '/:organization',
    CUSTOM_FORGOT_PASSWORD: '/:organization/forgot-password',


    /** New pages **/
    DASHBOARD: '/dashboard',
    USERS: '/users',
    USER_UPDATE: '/user/:id',
    CHANGE_PASSWORD: '/profile/change-password',
    DELETED_USERS: '/deleted/users',
    RESELLERS: '/resellers',
    RESELLER_UPDATE: '/reseller/:id',
    RESELLERS_CREATE: '/resellers/create',
    ORGANIZATIONS: '/organizations',
    DELETED_ORGANIZATIONS: '/deleted/organizations',
    ORGANIZATION_CREATE: '/organization/create/:tab?',
    ORGANIZATION_UPDATE: '/organization/:id/:tab?',
    MAINTENANCE_MODE: '/maintenance-mode',
    MAINTENANCE_MODE_DASHBOARD: '/maintenance-mode-dashboard'
};

export default Object.freeze(enums);
